export default {
    ThreePartySalesOrder: {
        Channel: '渠道',
        Store: '店铺',
        After: '售后类型',
        Platform: '平台状态',
        Internal: '内部单号',
        order: '内部订单号/内部售后单号',
        Tripartite: '三方单号',
        Third: '三方售后单号/客户订单号/三方换货单号',
        Return: '退回物流',
        logistics: '退回物流单号',
        Circulation: '商品流转状态',
        sales: '售后阶段',
        reasons: '平台售后原因',
        nickname: '买家昵称',
        Application: '申请售后时间',
        Refund: '退款成功时间',
        Timeout: '超时时间',
        Creation: '创建时间',
        Add: '新增三方售后单',
        push: '推送',
        confirmation: '转正',
        ReleaseHold: '解除暂停',
        HoldOrder: '暂停订单',
        OnHold:'暂停',
        OnHoldStatus:'暂停状态',
        Manually: '手工下载授权店铺订单',
        download: '手工下载授权店铺订单（按单号）',
        authorized: '手工下载授权店铺订单（按时间）',
        Online: '线上订单号（每行一个订单号,换行输入或以英文逗号,分隔输入 最大允许输入100个单号）',
        Please: '请选择异常单',
        selectDataWarning: '至少选择一条数据!',
        selectDataWarning1: '最多选择200条数据!',
        selectDataWarning2: '至少选择一条 相关类型 数据!',
        selectDataWarning3: '您选中了 已完成/已取消 的订单，不可再次取消！',
        msgError: '文件已提交，可点击 导入历史 查看导入结果',
        msgError1: '选中了已禁用数据，不可再次禁用。',
        form: {
            number: '三方售后单号',
            Reason: '流转异常原因',
            Aftersales: '售后回传状态',
            Customer: '客服介入',
            Transaction: '交易金额',
            Refund: '退款金额',
            quantity: '退款数量',
            Remarks: '备注',
            Original: '原始单收件地址',
            After: '售后完成时间',
            time: '修改时间',
            Creation: '创建时间',
            Timeout: '超时时间',
            Operator: '操作人',
            Third: '三方换货单号',
            Shipping: '发出物流',
            Issue: '发出物流单号',
            logistics: '同步物流状态',
            failure: '物流同步失败原因',
            refundMethod: '退款方式',
            isExport: '导出状态'
        }
    }
};
